import React from 'react';
import {t, Trans} from '@lingui/macro';

export const AssetRepostInfo = {
    title: () => t`Repost Depreciations`,
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.update_confirm = true;
        handleOk(newAction);
    },
    noPasscode: true,
    bodyStyle: { paddingBottom: 16 },
    okText: 'Save',
};

function AssetRepost() {
    return (
        <span>
            <p>
                <Trans>
                    The changes you made will cause all depreciations to be reposted for this fixed asset.
                    Do you want to proceed?
                </Trans>
            </p>
        </span>
    );
}

export default AssetRepost;
